import React from "react";
import PropTypes from "prop-types";
import mainStore from "../../../../../stores/main";
var StepScore = function StepScore(_ref) {
  var points = _ref.points,
    score = _ref.score,
    stepsNumber = _ref.stepsNumber,
    currentStepIndex = _ref.currentStepIndex,
    wasClicked = _ref.wasClicked;
  var scoreActive = wasClicked && currentStepIndex === 0 || currentStepIndex > 0 ? "active" : "";
  return /*#__PURE__*/React.createElement("div", {
    className: "step__score ".concat(scoreActive)
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__score__header"
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: mainStore.dictionary.Quiz.yourScore
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "step__score__icon"
  })), /*#__PURE__*/React.createElement("p", {
    className: "step__score__points"
  }, score, "/", points * (stepsNumber - 1)));
};
export default StepScore;
StepScore.propTypes = {
  points: PropTypes.number.isRequired,
  score: PropTypes.number.isRequired,
  stepsNumber: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  wasClicked: PropTypes.bool.isRequired
};